// Vendor JS
import Debug from 'debug';
import axios from 'axios';
import merge from 'deepmerge';

// Custom JS
import httpBuildQuery from './http-build-query';
import { isCamelCase } from './camelCase';

/**
 * Make a CIG API call
 *
 * @param {string} controller The name of the API controller class
 * @param {string} action The name of the API controller class method to be executed
 * @param {Object} payload The data to be sent to the API
 *
 * @returns {AxiosPromise} The response from the API
 */
const apiCall = async (controller, action, payload) => {
	// Make sure the data argument is an object
	if (typeof payload !== 'object') {
		throw new TypeError('The data argument must be a valid object');
	}

	// Make sure the controller and action are kebab-case and not camelCase
	if (isCamelCase(controller) || isCamelCase(action)) {
		throw new Error('The controller and action arguments should not be camelCase, they should be kebab-case instead');
	}

	// Deep Merge the passed in object with this object so it has the proper API cmd property in the query string
	const postData = merge({
		cmd: (`${controller}/${action}`).toLowerCase()
	}, (payload || {}));

	return axios.post(`/request.php?`, httpBuildQuery(postData));
};

/**
 * Make a CIG API request with error handling, this is the function that should be imported and used elsewhere
 *
 * @param {string} controller The name of the API controller class
 * @param {string} action The name of the API controller class method to be executed
 * @param {Object} payload The data to be sent to the API
 *
 * @returns {AxiosResponse} The response from the API
 */
const cigAPI = async (controller, action, payload) => {
	try {
		return await apiCall(controller, action, payload);
	} catch (err) {
		Debug(`cig:error:sage:function:cigAPI`)(`cigAPI Error: %s %o`, err.message, err);
		throw new Error(err);
	}
};

export default cigAPI;
